import React from 'react'

export default function SectionsHeading({ children, title, desc, titleClass, descClass }) {
    return (
        <>
            <div className="section-heading display-inline">
                {
                    title ? (<h5 className={'sec__title '+titleClass}>{title}</h5>) : ' '
                }
                {
                    desc ? (<p className={'sec__desc '+descClass}>{desc}</p>) : ' '
                }
            </div>
            {children}
        </>
    )
}
